import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage.ts';
import { useAccessLinkEditMode } from '@confluence/external-share-context/entry-points/AccessLinkEditMode.ts';

import { PageMode } from './enums.ts';

export const useGetPageMode = (): PageMode => {
	const isLivePage = useIsCurrentPageLive();
	const isEditorPage = useIsEditorPage();

	// An in-place Access Link editor is never on an edit route, so `useIsEditorPage` alone would
	// report view mode and the header would render no publish affordance.
	const { isAvailable: isAccessLinkEdit, isEditMode: isAccessLinkEditing } =
		useAccessLinkEditMode();

	let pageMode = PageMode.VIEW;
	if (isLivePage) {
		pageMode = PageMode.LIVE;
	} else if (isEditorPage || (isAccessLinkEdit && isAccessLinkEditing)) {
		pageMode = PageMode.EDIT;
	}

	return pageMode;
};
